export default __webpack_public_path__ + "static/media/score.2a561b90.png";